import { atom } from "recoil";
import { persistAtom } from "./persist";

export const PreviewMuteState = atom({
  key: "PreviewMuteState_V0.1",
  default: true,
  effects_UNSTABLE: [persistAtom],
});

export const ManualVolumeInteractionState = atom({
  key: "ManualVolumeInteractionState_V0.1",
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export const ActiveClipAtom = atom<string | null>({
  key: "ActiveClipPlayerAtom",
  default: null,
});

export const ProfileFirstClipUrlAtom = atom<string | undefined>({
  key: "ProfileFirstClipUrlAtom",
  default: undefined,
});
